import {useMemo} from "react";
import {
  freightTypeCategoriesSelector,
  FreightTypeSelectorProps,
  useGetAllFreightTypesQuery
} from "@ots-frontend/ots-data";
import {BaseAutocomplete, BaseAutocompleteProps} from '../../BaseAutocomplete/BaseAutocomplete'

export type FreightTypeCategoryAutocompleteProps = Omit<BaseAutocompleteProps, "data" | "loading"> & {
  selector?: FreightTypeSelectorProps
}

export const FreightTypeCategoryAutocomplete = (props: FreightTypeCategoryAutocompleteProps) => {
  const {selector, ...rest} = props;

  const selectFreightTypeCategories = useMemo(() => {
    return freightTypeCategoriesSelector();
  }, []);

  const {freightTypeCategories, isLoading} = useGetAllFreightTypesQuery(selector?.regionId, {
    selectFromResult: (result) => ({
      freightTypeCategories: selectFreightTypeCategories(result, selector),
      isLoading: result.isLoading
    })
  });

  return <BaseAutocomplete data={freightTypeCategories} loading={isLoading} {...rest} />;
};
